import React, {useCallback} from 'react';
import {raiseFlashMessageError} from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import vettingFetchers from '@/api/fetchers/vetting';
import useBrandId from '@/hooks/use-brand-id';
import useNavigation from '@/hooks/use-navigation';

function useNavigateToLatestReport(
  creatorId: string,
  scope?: 'brand' | 'agency',
  from?: string
) {
  const brandId = useBrandId();
  const {navigate} = useNavigation();

  return useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      try {
        const response = await vettingFetchers.latestReportId(
          creatorId,
          brandId,
          scope
        );
        const reportId = response.data?.reportId;
        if (reportId) {
          navigate(
            `/vetting/creators/${creatorId}/report/${reportId}?brandId=${brandId}${from ? `&from=${from}` : ''}`
          );
        } else {
          raiseFlashMessageError({
            title: translate('No report available for this creator'),
            subtitle: translate('Please try again or come back later'),
          });
        }
      } catch (error) {
        console.error('Failed to fetch latest report:', {
          creatorId,
          brandId,
          scope,
          error,
        });
        raiseFlashMessageError({
          title: translate('Failed to load report'),
          subtitle: translate('Please try again or come back later'),
        });
      }
    },
    [creatorId, brandId, scope, from, navigate]
  );
}

export default useNavigateToLatestReport;
